import Footer from "../constant-screens/footer";
import Header from "../constant-screens/header";
import Navbar from "../constant-screens/navbar";
import AboutScreenBody from "../half-screens/aboutScreenBody";

function AboutScreen() {
 return(
  <div>
   <Header />
   <Navbar />
   <AboutScreenBody />
   <Footer />
  </div>
 );
}

export default AboutScreen;